import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMatch } from 'react-router-dom'
import APP_URL, { LONG_NAME } from '../declaration/URL';

const useSetDefaultStateManageSettingSearch = () => {
  const dispatch = useDispatch();

  // 社員管理
  const matchEmployee = useMatch(LONG_NAME(APP_URL.portal.employee)); // "/app/portal/company/employee/"
  const matchEmployeeDetail = useMatch(LONG_NAME(APP_URL.portal.employeeRegister)); //"/app/portal/company/employee/register/"
  // 事業者指定番号管理
  const matchCompanyRegno = useMatch(LONG_NAME(APP_URL.portal.companyregno)); // "/app/portal/company/regno/"
  const matchCompanyRegnoDetail = useMatch(LONG_NAME(APP_URL.portal.companyregnoRegister)); //"/app/portal/company/regno/register/"
  // 得意先管理
  const matchCompanyCustomer = useMatch(LONG_NAME(APP_URL.portal.customer)); //"/app/portal/company/customer/"
  const matchCompanyCustomerDetail = useMatch(LONG_NAME(APP_URL.portal.customerRegister));
  const matchCompanyCustomerRegnoDetail = useMatch(LONG_NAME(APP_URL.portal.customerRegno)); // "/app/portal/company/customer/regno/
  const matchCompanyCustomerRegnoRegisterDetail = useMatch(LONG_NAME(APP_URL.portal.customerRegnoRegister)); // "/app/portal/company/customer/regno/register/"
  const matchCompanyCustomerEmployeeDetail = useMatch(LONG_NAME(APP_URL.portal.customerEmployee)) // "/app/portal/company/customer/employee/"
  // 得意先担当者管理
  const matchCustomerEmployee = useMatch(LONG_NAME(APP_URL.portal.customerEmployee)); // "/app/portal/company/customer/employee/"
  const matchCustomerEmployeeDetail = useMatch(LONG_NAME(APP_URL.portal.customerEmployeeRegister)); // "/app/portal/company/customer/employee/register/"
  // 日報管理
  const matchDairyReport = useMatch(LONG_NAME(APP_URL.dairyReport.dairyReport)); // "/app/dairy-report/"
  const matchDairyReportDetail = useMatch(LONG_NAME(APP_URL.dairyReport.register)); // "/app/dairy-report/register/"
  // 日報管理-テンプレート設定
  const matchDairyReportTemplates = useMatch(LONG_NAME(APP_URL.dairyReport.templates)); // "/app/dairy-report/templates/"
  const matchDairyReportTemplateRegister = useMatch(LONG_NAME(APP_URL.dairyReport.templateRegister)); // "/app/dairy-report/template/register/"
  // 日報管理-リスト項目設定
  const matchDairyReportListItems = useMatch(LONG_NAME(APP_URL.dairyReport.listItems)); // "/app/dairy-report/list-items/"
  const matchDairyReportListItemsRegister = useMatch(LONG_NAME(APP_URL.dairyReport.listItemsRegister)); // "/app/dairy-report/list-items/register/"
  // 勤怠管理-部署パターン管理
  const matchAttendanceDepartment = useMatch(LONG_NAME(APP_URL.attendance.departmentSetting)); // "/app/attendance/setting/setting4/"
  const matchAttendanceDepartmentDetail = useMatch(LONG_NAME(APP_URL.attendance.departmentSettingRegister)); // "/app/attendance/setting/setting4/register/"
  // 勤怠管理-社員パターン管理
  const matchAttendanceEmployee = useMatch(LONG_NAME(APP_URL.attendance.employeeSetting)); // "/app/attendance/setting/setting5/"
  const matchAttendanceEmployeeDetail = useMatch(LONG_NAME(APP_URL.attendance.employeeSettingRegister)); // "/app/attendance/setting/setting5/register/"
  // 資格管理
  const matchEmployeeCertification = useMatch(LONG_NAME(APP_URL.portal.employeeCertification)); // "/app/portal/company/employee-certification/"
  const matchEmployeeCertificationDetail = useMatch(LONG_NAME(APP_URL.portal.employeeCertificationRegister)); // "/app/portal/company/employee-certification/register/"
  // 資格マスタ設定
  const matchCompanyCertificationMst = useMatch(LONG_NAME(APP_URL.portal.certificationMst)); // "/app/portal/company/certification-mst/"
  const matchCompanyCertificationMstDetail = useMatch(LONG_NAME(APP_URL.portal.certificationMstRegister)); // "/app/portal/company/certification-mst/register/"
  // 得意先資格管理
  const matchCustomerEmployeeCertification = useMatch(LONG_NAME(APP_URL.portal.customerEmployeeCertification));
  const matchCustomerEmployeeCertificationDetail = useMatch(LONG_NAME(APP_URL.portal.customerEmployeeCertificationRegister)); // "/app/portal/company/customer/customer-employee-certification/register/"
  // システム定義資格
  const matchSystemCertificationMst = useMatch(LONG_NAME(APP_URL.portal.systemCertificationMst));

  useEffect(() => {
    // 社員管理
    if (!matchEmployee && !matchEmployeeDetail && !matchEmployeeCertification) {
      sessionStorage.removeItem("/app/portal/company/employee_searchConditions"); 
      sessionStorage.removeItem("/app/portal/company/employee/register_searchConditions");
    }

    // 事業者指定番号管理
    if (!matchCompanyRegno && !matchCompanyRegnoDetail) {
      sessionStorage.removeItem("/app/portal/company/regno_searchConditions");
      sessionStorage.removeItem("/app/portal/company/regno/register_searchConditions");
    }

    // 得意先管理
    if (!matchCompanyCustomer && !matchCompanyCustomerDetail && !matchCompanyCustomerRegnoDetail && !matchCompanyCustomerRegnoRegisterDetail && !matchCompanyCustomerEmployeeDetail && !matchCustomerEmployeeCertification && !matchCustomerEmployeeCertificationDetail && !matchCustomerEmployeeDetail && !matchCompanyCertificationMst && !matchCompanyCertificationMstDetail && !matchSystemCertificationMst) {
      sessionStorage.removeItem("/app/portal/company/customer_searchConditions");
      sessionStorage.removeItem("/app/portal/company/customer/register_searchConditions");
      sessionStorage.removeItem("/app/portal/company/customer/employee_searchConditions");
    }

    // 得意先事業者指定番号管理: 一覧⇔追加/編集間でのみ保持し、得意先管理など他画面に遷移したらクリア
    if (!matchCompanyCustomerRegnoDetail && !matchCompanyCustomerRegnoRegisterDetail) {
      sessionStorage.removeItem("/app/portal/company/customer/regno_searchConditions");
    }

    // 得意先担当者管理
    if (!matchCustomerEmployee && !matchCustomerEmployeeDetail && !matchCustomerEmployeeCertification && !matchCustomerEmployeeCertificationDetail && !matchCompanyCertificationMst && !matchCompanyCertificationMstDetail && !matchSystemCertificationMst) {
      sessionStorage.removeItem("/app/portal/company/customer/employee_searchConditions");
      sessionStorage.removeItem("/app/portal/company/customer/employee/register_searchConditions");
    }

    // 日報管理
    if (!matchDairyReport && !matchDairyReportDetail) {
      sessionStorage.removeItem("/app/dairy-report_searchConditions");
      sessionStorage.removeItem("/app/dairy-report/register_searchConditions");
    }

    // 日報管理-テンプレート設定
    if (!matchDairyReportTemplates && !matchDairyReportTemplateRegister) {
      sessionStorage.removeItem("/app/dairy-report/templates_searchConditions");
      sessionStorage.removeItem("/app/dairy-report/template/register_searchConditions");
    }

    // 日報管理-リスト項目設定
    if (!matchDairyReportListItems && !matchDairyReportListItemsRegister) {
      sessionStorage.removeItem("/app/dairy-report/list-items_searchConditions");
      sessionStorage.removeItem("/app/dairy-report/list-items/register_searchConditions");
    }

    // 勤怠管理-部署パターン
    if (!matchAttendanceDepartment && !matchAttendanceDepartmentDetail) {
      sessionStorage.removeItem("/app/attendance/setting/setting4_searchConditions"); 
      sessionStorage.removeItem("/app/attendance/setting/setting4/register_searchConditions"); 
    }

    // 勤怠管理-社員パータン
    if (!matchAttendanceEmployee && !matchAttendanceEmployeeDetail) {
      sessionStorage.removeItem("/app/attendance/setting/setting5_searchConditions"); 
      sessionStorage.removeItem("/app/attendance/setting/setting5/register_searchConditions"); 
    }

    // 資格管理
    if (!matchEmployeeCertification && !matchEmployeeCertificationDetail && !matchCompanyCertificationMst && !matchCompanyCertificationMstDetail && !matchSystemCertificationMst) {
      sessionStorage.removeItem("/app/portal/company/employee-certification_searchConditions"); 
      sessionStorage.removeItem("/app/portal/company/employee-certification/register_searchConditions"); 
    }
    
    // 資格マスタ管理
    if (!matchCompanyCertificationMst && !matchCompanyCertificationMstDetail) {
      sessionStorage.removeItem("/app/portal/company/certification-mst_searchConditions"); 
      sessionStorage.removeItem("/app/portal/company/certification-mst/register_searchConditions"); 
    }

    // 得意先資格管理
    if (!matchCustomerEmployeeCertification && !matchCustomerEmployeeCertificationDetail && !matchCompanyCertificationMst && !matchCompanyCertificationMstDetail && !matchSystemCertificationMst) {
      sessionStorage.removeItem("/app/portal/company/customer/customer-employee-certification_searchConditions");  
      sessionStorage.removeItem("/app/portal/company/customer/customer-employee-certification/register_searchConditions"); 
    }
  }, [
    dispatch,
    matchEmployee, matchEmployeeDetail,
    matchCompanyRegno, matchCompanyRegnoDetail,
    matchCompanyCustomer, matchCompanyCustomerDetail, matchCompanyCustomerRegnoDetail, matchCompanyCustomerRegnoRegisterDetail, matchCompanyCustomerEmployeeDetail,
    matchDairyReport, matchDairyReportDetail,
    matchDairyReportTemplates, matchDairyReportTemplateRegister,
    matchDairyReportListItems, matchDairyReportListItemsRegister,
    matchAttendanceDepartment, matchAttendanceDepartmentDetail,
    matchAttendanceEmployee, matchAttendanceEmployeeDetail,
    matchEmployeeCertification, matchEmployeeCertificationDetail,
    matchCompanyCertificationMst, matchCompanyCertificationMstDetail,
    matchCustomerEmployeeCertification, matchCustomerEmployeeCertificationDetail, matchSystemCertificationMst
  ]);
};

export default useSetDefaultStateManageSettingSearch;
